import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { GraphDotnetService, graphql, Library, MediaclipMutationUpdateStoreConfigArgs, Store, UpdateStoreConfigInput } from 'app/shared/graph';

@Injectable({
    providedIn: 'root'
})
export class LibrarySettingsService {
    private readonly graphDotnetService = inject(GraphDotnetService);

    getStoreConfig(storeId: string): Observable<Store> {
        return this.graphDotnetService.query(graphql`
                query getStoreSettings($storeId: String!) {
                    store(id: $storeId) {
                        label
                        config {
                            defaultLibraryPackage
                            defaultLibraryBranches
                        }
                    }
                }
            `,
            {
                storeId
            }
        ).pipe(map(q => q.store));
    }

    updateStoreConfig(input: UpdateStoreConfigInput): Observable<void> {
        return this.graphDotnetService.mutate<MediaclipMutationUpdateStoreConfigArgs>(
            graphql`
                mutation updateStoreConfig($input: UpdateStoreConfigInput!) {
                    updateStoreConfig(input: $input)
                }
            `,
            { input }
        ).pipe(map(x => x.updateStoreConfig));
    }

    getLibrariesWithBranches(): Observable<Library[]> {
        return this.graphDotnetService.query(graphql`
            query getLibraries {
                libraries {
                    owner
                    branches {
                        name
                    }
                }
            }`).pipe(map(q => q.libraries));
    }
}
